import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withRouter } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import http from '../../services/http';
import Loader from '../loader/loader';

import './registrationForm.less';

class RegistrationForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      values: {},
      errors: {},
      loading: false,
    };
  }

  onFieldChange = fieldName => e => {
    const { value } = e.target;

    this.setState(state => ({
      ...state,
      values: {
        ...state.values,
        [fieldName]: value,
      },
      errors: {
        ...state.errors,
        [fieldName]: null,
      },
    }));
  }

  onSwitchChange = fieldName => e => {
    const event = {
      target: {
        value: !!e.target.checked,
      },
    };
    this.onFieldChange(fieldName)(event);
  }

  onSubmit = async e => {
    e.preventDefault();
    this.setState({ loading: true });

    const { values } = this.state;

    try {
      await http.post('/api/auth/register', values);
      this.setState({ loading: false });
    } catch (error) {
      console.error(error); // eslint-disable-line no-console

      this.setState({ loading: false });

      const errorMessage = error.status === 409
        ? 'Inny użytkownik używa już tego adresu email!'
        : 'Nie udało się wysłać danych!';
      NotificationManager.error(errorMessage, 'Błąd', 5000);

      const { errors } = error;

      if (errors) {
        this.setState({ errors });
      }

      return null;
    }

    const { history } = this.props;
    return history.replace('/registration-success');
  }

  renderField = (fieldName, label, props = {}) => {
    const { errors } = this.state;
    // eslint-disable-next-line react/destructuring-assignment
    const [error] = errors[fieldName] || [];

    return (
      <TextField
        onChange={this.onFieldChange(fieldName)}
        variant="outlined"
        label={label}
        error={!!error}
        helperText={error}
        fullWidth
        {...props}
      />
    );
  }

  render() {
    const { loading, values } = this.state;

    return (
      <form className="registration-form-container" onSubmit={this.onSubmit} noValidate>
        {loading && <Loader />}

        <Grid container spacing={2}>
          <Grid item xs={12}>
            {this.renderField('UserName', 'Login (e-mail)', { required: true, type: 'email' })}
          </Grid>
          <Grid item xs={12}>
            {this.renderField('Password', 'Hasło', { required: true, type: 'password' })}
          </Grid>
          <Grid item xs={12}>
            {this.renderField('PasswordConfirmation', 'Powtórz hasło', { required: true, type: 'password' })}
          </Grid>
        </Grid>

        <div className="personal-data-container">
          <Typography variant="overline">
            Dane osobowe
          </Typography>
        </div>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControlLabel
              control={(
                <Switch
                  onChange={this.onSwitchChange('IsCompany')}
                />
            )}
              label="Rejestruję się jako firma"
            />
          </Grid>
          <Grid item xs={12}>
            {this.renderField('Name', 'Imię i nazwisko / Nazwa firmy', { required: true })}
          </Grid>

          <Grid item xs={12}>
            {this.renderField('PhoneNumber', 'Numer telefonu', { required: true })}
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField onChange={this.onFieldChange('Street')} variant="outlined" label="Adres" fullWidth />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField onChange={this.onFieldChange('City')} variant="outlined" label="Miasto" fullWidth />
          </Grid>

          <Grid item xs={12} md={4}>
            {this.renderField('PostCode', 'Kod pocztowy')}
          </Grid>

          {!!values.IsCompany && (
            <Grid item xs={12}>
              {this.renderField('NIP', 'NIP')}
            </Grid>
          )}
        </Grid>

        <div className="send-button-container">
          <Button size="large" variant="contained" color="primary" type="submit">
            Zarejestruj
          </Button>
        </div>
      </form>
    );
  }
}

RegistrationForm.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func,
  }).isRequired,
};

export default withRouter(RegistrationForm);
